<template>
    <div>
        <div class="reloadIndicator" :style="{opacity:refreshAlpha, transform: 'scale('+refreshAlpha+')'}">
            <span v-if="!isRefreshing">refresh</span>
        </div>
        <post-item v-for="post in posts" :post="post" :key="post._id"></post-item>
        <div class="clearfix"></div>
        <div class="indicator-container">
            <loading-indicator name="posts.get"/>
            <loading-indicator name="likedposts.get"/>
        </div>
    </div>
</template>

<script>
    import PostListItem from '../posts/PostListItem.vue';
    import PostItem from "./PostListItem.vue";
    import LoadingIndicator from "../ui/LoadingIndicator.vue";


    export default {
        name: 'PostList',
        props: ['blog', 'attachScrollListener', 'type'],
        data() {
            return {
                wasLastPost: false,
                itemsPerPage: 0,
                isLoading: false,
                posts: [],
                isRefreshing: false,
                refreshAlpha: 0,
                scrollContainer: document,
                instanceCount: 0,
                lastLikeId: 0
            }
        },
        computed: {
            isActivePlaylist(){
                return this.instanceCount < 2;
            }
        },
        watch: {
            type(newVal, oldVal){
                this.wasLastPost = false;
                this.posts = [];
                this.lastLikeId = 0;
                this.loadPosts();
            },
            blog(newVal, oldVal){
              this.wasLastPost = false;
              this.posts = [];
              this.lastLikeId = 0;
              this.loadPosts();
            }
        },
        mounted() {

            if(this.attachScrollListener && this.attachScrollListener.scrollContainer){
              this.scrollContainer = this.attachScrollListener.scrollContainer;
            }
            this.loadPosts();
            this.scrollContainer.addEventListener("scroll", this.scrollListener);

            // Needed to determine, which 'playlist' should respost to player events
            this.$bus.$on('postlist.add', (data)=>this.instanceCount++);
            this.$bus.$on('postlist.remove', (data)=>this.instanceCount--);
            this.$bus.$emit('postlist.add', {parent: this.$parent.$options.name})

            this.$bus.$on('hasPlaylist',   (cb)  =>{ if(this.isActivePlaylist) cb(true) });
            this.$bus.$on('playNextVideo', (post)=>{ if(this.isActivePlaylist) this.playNextVideo(post) });
            this.$bus.$on('playPrevVideo', (post)=>{ if(this.isActivePlaylist) this.playPrevVideo(post) });
            this.$bus.$on('post.deleted', (post) =>{
              this.posts.splice(this.posts.findIndex((item)=>item===post),1);
            });
            this.$bus.$on('post.unliked', (post) =>{
              if(this.type === 'likes') this.posts.splice(this.posts.findIndex((item)=>item===post),1);
            });

        },
        beforeDestroy(){
            this.scrollContainer.removeEventListener('scroll', this.scrollListener);
            this.$bus.$emit('postlist.remove', {parent: this.$parent.$options.name})
        },
        methods: {
            scrollListener(){

                let reloadOffset = 450;
                let offset    = (this.scrollContainer.scrollTop) ? this.scrollContainer.scrollTop : window.pageYOffset;
                let scrollPos = offset + window.innerHeight;
                let docHeight = (this.scrollContainer.scrollHeight) ? this.scrollContainer.scrollHeight : document.body.scrollHeight;

                if(!this.wasLastPost && !this.isLoading && Math.abs(scrollPos - docHeight) < reloadOffset){
                    this.isLoading = true;
                    this.loadPosts();
                }

                if(offset < 0){
                    let a = Math.abs(offset)  / 100;
                    if(a>1){
                        a = 1;
                        if(!this.isRefreshing){
                            this.posts = [];
                            this.loadPosts();
                            this.isRefreshing = true;
                        }
                    }
                    this.refreshAlpha = a;
                } else {
                    if(this.isRefreshing) this.isRefreshing = false;
                }
            },
            loadPosts(){
                let lastId = 0;
                if(this.posts.length > 0){
                    let lastPost = this.posts[this.posts.length-1];
                    lastId = lastPost._id;
                }
                if(this.blog){
                    if(this.posts.length > 0 && !this.$store.state.user.isLoggedIn){
                        this.$swal({
                            title: "Like this Blog?",
                            text: "Please Login/Register to see more!",
                            showCancelButton: true,
                            confirmButtonText: 'Login',
                            confirmButtonColor: '#d618e7'
                        }).then((val)=>{
                            this.$router.push({name:'Login'});
                        });
                        return;
                    }
                    this.$api.getBlogPosts(this.blog.url, lastId).then(this.processPosts);
                    return;
                }

                if(this.type === 'likes'){
                    this.$api.getLikedPosts(this.lastLikeId).then(this.processPosts);
                    return;
                }

                this.$api.getPosts(lastId).then(this.processPosts);
            },
            processPosts(res){
                let posts = res.data.posts;
                if(posts.length === 0 && this.posts.length === 0) this.$bus.$emit('postlist.noresults', {type: this.type});
                if(res.data.lastLikeId) this.lastLikeId = res.data.lastLikeId;
                if(this.itemsPerPage < posts.length) this.itemsPerPage = posts.length;
                if(posts.length < this.itemsPerPage) this.wasLastPost = true;
                posts.forEach((post)=>this.posts.push(post));
                this.isLoading = false;
            },
            playNextVideo(lastPost){
                let nextPost = null;
                let isNext   = false;
                let plPos    = 0;
                for(let i in this.posts){
                    plPos = i;
                    let post = this.posts[i];
                    if(isNext){
                        nextPost = post;
                        break;
                    }
                    if(lastPost._id === post._id) isNext = true;
                }
                // Play Next
                if(nextPost) this.$bus.$emit('playVideo', nextPost);

                // Load More?
                if(plPos < this.posts.length - 3){
                    if(!this.wasLastPost && !this.isLoading){
                        this.isLoading = true;
                        this.loadPosts();
                    }
                }
            },
            playPrevVideo(lastPost){
                let prevPost = null;
                for(let i in this.posts){
                    let post = this.posts[i];
                    if(lastPost._id === post._id) break;
                    prevPost = post;
                }
                if(prevPost) this.$bus.$emit('playVideo', prevPost);
            }
        },
        components: {
            LoadingIndicator,
            PostItem,
            'post-item': PostListItem
        }
    }
</script>

<style lang="sass">
    .indicator-container
        height: 80px


    .reloadIndicator
        position: absolute
        top: 0px
        text-align: center
        width: 100%
        opacity: 0

</style>



// WEBPACK FOOTER //
// src/components/posts/PostList.vue